import React from 'react';

import {CustomCardTitle, Grade} from 'components/form/components';

import {ICustomCardStyleProps} from '../../../../form/components/custom-card-title/custom-card-title';

interface IRequestHeaderProps {
    text: string;
    requestFormKey: string;
    value?: number;
    commentId?: string;
    url?: string;
    customCardStyleProps?: ICustomCardStyleProps;

}
export const RequestHeader = ({
    customCardStyleProps,
    text,
    value,
    commentId,
    requestFormKey,
    url,
}:IRequestHeaderProps) => (
    <CustomCardTitle
        customCardStyleProps={customCardStyleProps}
        text={text}
        extra={(
            <Grade
                value={value}
                commentId={commentId}
                requestFormKey={requestFormKey}
                url={url}
            />
        )}
    />
);
